/**
 * @owner @Appboy/reporting
 */

export const creditRatios = "/analytics_dashboard/:app_group_id/credit_ratios_detail_data";
